import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Creators as TaskCreators } from 'store/ducks/task';
import { Creators as LocalsCreators } from 'store/ducks/locals';

import { InputText } from 'triider-components';

import Modal from 'components/Modal';
import PaymentInfoStep from './PaymentInfoStep';

import {
  Content, BackButton, ContentText, ExternalCode,
} from './styles';

const AuthorizeModal = ({
  isOpen,
  toggle,
  isLoading,
  onFinish,
  taskQuoteProDetail,
  taskDetail,
  triiderUser,
  _taskPaymentInfo,
  _editLocal,
}) => {
  const [step, setStep] = useState(2);
  const [isEditing, setIsEditing] = useState(false);
  const [billingType, setBillingType] = useState('');
  const [fields, setFields] = useState({});
  const [externalId, setExternalId] = useState('');

  const initialState = () => {
    setBillingType('Imobiliária');
    setFields({
      name: triiderUser.company.name || '',
      email: triiderUser.user.email || '',
      cnpj: triiderUser.company.cnpj || '',
      cep: '',
    });

    if (!taskDetail.taskAddress.external_id) {
      setStep(1);
    } else if (!taskDetail.billing_info) {
      setStep(2);
    } else {
      const {
        from_type, name, email, cpf, cnpj,
      } = taskDetail.billing_info;
      setStep(3);
      setIsEditing(true);
      setBillingType(from_type);
      setFields({
        name,
        email,
        cpf,
        cnpj,
      });
    }
  };

  useEffect(() => {
    initialState();
  }, [taskDetail]);

  const changeExternalId = ({ target: { value } }) => {
    setExternalId(value);
  };

  const goEditPayment = () => {
    setStep(2);
    setIsEditing(true);
  };

  const handleStep = () => {
    switch (step) {
      case 1:
        return (
          <Content>
            <p>Você deseja adicionar um identificador para o endereço:</p>
            <p>
              <strong>{taskDetail.address}</strong>
            </p>
            <ExternalCode>
              <InputText
                placeholder="Código Identificador:"
                type="text"
                onChange={changeExternalId}
              />
            </ExternalCode>
          </Content>
        );

      case 2:
        return (
          <PaymentInfoStep
            isLoading={isLoading}
            taskDetail={taskDetail}
            triiderUser={triiderUser}
            billingType={billingType}
            fields={fields}
            setBillingType={setBillingType}
            setFields={setFields}
          />
        );
      case 3:
        return (
          <Content>
            <BackButton onClick={() => goEditPayment()}>
              ALTERAR INFORMAÇÕES DE PAGAMENTO
            </BackButton>
            <ContentText>
              Ao autorizar este orçamento, o usuário poderá contratar este e quaisquer outros
              profissionais que forem autorizados por você.
            </ContentText>
          </Content>
        );
      default:
        return <div />;
    }
  };

  const handleNextClick = async () => {
    switch (step) {
      case 1:
        if (externalId) {
          _editLocal({
            id: taskDetail.address_id,
            external_id: externalId,
            company_id: taskDetail.company_id,
          });
        } else if (!taskDetail.billing_info) {
          setStep(2);
        } else {
          setStep(3);
        }
        break;

      case 2:
        if (billingType === 'Imobiliária') {
          _taskPaymentInfo({
            ...fields,
            billing_address_info: {
              cep: fields.cep,
              number: fields.number,
              state_initials: fields.state_initials,
              state_id: fields.state_id,
              state_name: fields.state_name,
              district: fields.district,
              city_name: fields.city_name,
              city_id: fields.city_id,
              address:fields.address,
              address_details: fields.address_details,
            },
            company: triiderUser.company,
            user_id: triiderUser.user.id,
            task_id: taskDetail.id,
            from_type: billingType,
            address_id: triiderUser.company.billing_address ? triiderUser.company.billing_address.address_id : taskDetail.address_id,
            update: isEditing,
          });
        } else {
          _taskPaymentInfo({
            ...fields,
            billing_address_info: {
              cep: fields.cep,
              number: fields.number,
              state_initials: fields.state_initials,
              state_id: fields.state_id,
              state_name: fields.state_name,
              district: fields.district,
              city_name: fields.city_name,
              city_id: fields.city_id,
              address:fields.address,
              address_details: fields.address_details,
            },
            company: triiderUser.company,
            user_id: triiderUser.user.id,
            task_id: taskDetail.id,
            from_type: billingType,
            address_id: taskDetail.address_id,
            update: isEditing,
          });

        }

        break;

      default:
        break;
    }
  };

  const authorize = () => {
    onFinish({
      quoteId: taskQuoteProDetail.id,
      userId: taskQuoteProDetail.user_id,
    });
  };

  const disableFooterClick = () => step === 2 && (!fields.name || !fields.email || !fields.cep || (!fields.cpf && !fields.cnpj));
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      title="AUTORIZAR ORÇAMENTO"
      footer={step === 3 ? 'Autorizar' : 'Próximo'}
      disabled={disableFooterClick()}
      footerClick={() => (step === 3 ? authorize() : handleNextClick())}
    >
      {handleStep(step)}
    </Modal>
  );
};

const mapStateToProps = state => ({
  triiderUser: state.auth.triiderUser,
  isLoading: state.task.loading,
});

const mapDispatchToProps = {
  _taskPaymentInfo: TaskCreators.taskPaymentInfoRequest,
  _editLocal: LocalsCreators.editLocalRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthorizeModal);
